import { useSelector, useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error Cannot find declaration for module
import { getIsReadOnlyMode } from 'EmailEditorUI/redux/selectors/ReadOnlySelector';
// @ts-expect-error Cannot find declaration for module
import { getIsSingleColumnFullWidth } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { LAYOUTS } from 'EmailEditorUI/constants/SectionLayoutConstants';
import ExpandableSectionBorderlessHeader from 'messaging-editing-lib/utilityUI/ExpandableSectionBorderlessHeader';

// @ts-expect-error Cannot find declaration for module
import LayoutTile from 'LayoutBuilderUI/components/tiles/LayoutTile';
import ExpandableSectionContentWrapper from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/ExpandableSectionContentWrapper';
import AddPanelExpandableSection from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/AddPanelExpandableSections';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultSections = () => {
  const dispatch = useDispatch();
  const isReadOnlyMode = useSelector(getIsReadOnlyMode);
  const isSingleColumnFullWidth = useSelector(getIsSingleColumnFullWidth);
  const layoutKeys = Object.keys(LAYOUTS);
  return /*#__PURE__*/_jsx(AddPanelExpandableSection, {
    name: "default-sections-section",
    Header: ExpandableSectionBorderlessHeader,
    removeRightPaddingFromContent: true,
    "data-test-id": "default-sections",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "layoutBuilder.addPanel.defaultSections.header"
    }),
    indentation: "compact",
    children: /*#__PURE__*/_jsx(ExpandableSectionContentWrapper, {
      numberOfTiles: layoutKeys.length,
      children: layoutKeys.map(layout => /*#__PURE__*/_jsx(LayoutTile, {
        layout: layout,
        dispatch: dispatch,
        disabledMessage: isSingleColumnFullWidth ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "layoutBuilder.layouts.layoutDisabled"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.readOnly.title"
        }),
        disabled: isSingleColumnFullWidth || isReadOnlyMode
      }, layout))
    })
  });
};
export default DefaultSections;